import React, { FC } from 'react';
import { Card, Pagination, Paper, Stack, Table, TableBody, TableContainer } from '@mui/material';
import { useUiContext } from 'src/UIProvider';
import { observer } from 'mobx-react-lite';
import { TableHeader } from 'src/UIKit/TableHeader';
import { useMagazineCategoriesTable } from 'src/modules/magazineCategory/presenters/useMagazineCategoriesTable';
import { magazineCategoryModel } from 'src/modules/magazineCategory/entity/magazineCategory/MagazineCategoryModel';
import { ListToolbar } from 'src/UIKit/listToolbar';
import { MagazineCategoriesTableRow } from '../tableRow';
import { TableEmptyList } from 'src/UIKit/tableEmptyList';

export const MagazineCategoriesTable: FC = observer(() => {
    const { t } = useUiContext();
    const { rowsPerPage, page, search, onSearch, onChangePage, onChangeRowsPerPage, scrollRef } = useMagazineCategoriesTable();
    const count = magazineCategoryModel.magazineCategories?.count ? Math.ceil(magazineCategoryModel.magazineCategories.count / 30) : 1;
    const TABLE_HEAD = [t('common.name'), t('common.description'), t('common.actions')];

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <ListToolbar search={search} onSearch={onSearch} placeholder={t('content.searchByName')} />
            <TableContainer sx={{ height: "calc(100vh - 350px)", position: "relative" }} ref={scrollRef}>
                <Table>
                    <TableHeader headLabels={TABLE_HEAD} /> 
                    <TableBody>
                        {magazineCategoryModel.magazineCategories?.rows.map((item) => (
                            <MagazineCategoriesTableRow item={item} key={item.id} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Stack direction='row' justifyContent='center' my={1.5}>
                <Pagination
                    page={page + 1}
                    count={count}
                    color="primary"
                    onChange={onChangePage}
                />
            </Stack>
        </Paper>
    );
})